import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { Plus as PlusIcon } from 'react-feather'
import PropTypes from 'prop-types'

import { Permitted } from 'components'
import AddSubCategoryDialog from '../AddSubCategoryDialog'

import constants from 'constants/index'

const AddSubCategoryButton = ({ categoryId, onSuccess, disabled }) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Permitted tag={constants.permissions.COMPLAINTS.MANAGE_CONFIGURATIONS}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<PlusIcon size={16} />}
        disabled={disabled}
      >
        Adicionar
      </Button>
      <AddSubCategoryDialog
        open={open}
        onClose={handleClose}
        onSuccess={onSuccess}
        categoryId={categoryId}
      />
    </Permitted>
  )
}

AddSubCategoryButton.propTypes = {
  categoryId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

AddSubCategoryButton.defaultProps = {
  disabled: false,
}

export default AddSubCategoryButton
